let $grid = $('.projects-wrapper');
let $pagination = $('#projectsPagination');
let masonryOptions = {
  itemSelector: '.grid-item',
  columnWidth: '.grid-sizer',
  percentPosition: true,
  transitionDuration: 0,
};

let gup = (name, url) => {
  if (!url) url = location.href;
  name = name.replace(/[\[]/,"\\\[").replace(/[\]]/,"\\\]");
  let regexS = "[\\?&]"+name+"=([^&#]*)";
  let regex = new RegExp( regexS );
  let results = regex.exec( url );
  return results == null ? null : results[1];
};

export default {
  init() {

    $('#pagination').hide();
    $('#notFound').hide();

    let url = window.location.href;
    let category = gup('category', url);
    let type = '';

    let data = {
      'action'    : 'ili_project_filter',
      'category'  : category,
      'type'      : type,
    };

    $pagination.pagination({
      dataSource: function(done) {
        $.ajax({ // you can also use $.post here
          url : ili_project_filter.ajaxurl, // AJAX handler
          data : data,
          type : 'POST',
          async: true,
          success : function( response ) {
            done(response);
          },
        })
      },
      showPrevious: false,
      showNext: false,
      pageSize: 4,
      callback: function(data, pagination) {
        if (pagination.totalNumber === 0) {
          $('#pagination').hide();
          $('#notFound').show();
        } else {
          $('#pagination').show();
        }
        $('#loading').hide();
        $('#projectsGrid').html(data);
      },
      afterInit: function () {
        $grid.masonry(masonryOptions);
        $grid.imagesLoaded().progress( function() {
          $grid.masonry('layout');
        });
      },
      beforePageOnClick: function () {
        $grid.masonry('destroy');
        $('#pagination').hide();
        $('#notFound').hide();

        if (navigator.userAgent.match(/(iPod|iPhone|Android)/)) {
          $('html, body').animate({
            scrollTop: 300
          }, 'slow');
        } else if (navigator.userAgent.match(/(iPad)/)) {
          $('html, body').animate({
            scrollTop: 200
          }, 'slow');
        } else {
          let aTag = $('.project-types');
          $('html,body').animate({
            scrollTop: aTag.offset().top
          },'slow', function() {
            $('html,body').clearQueue();
          });
        }
      },
      afterPaging: function () {
        $grid.masonry(masonryOptions);
        $grid.imagesLoaded().progress( function() {
          $grid.masonry('layout');
        });
      }
    });


  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
    let $pjtTypes = $('input[name="projectType"]');

    $pjtTypes.click(function() {
      $('#loading').show();
      $('#pagination').hide();
      $('#notFound').hide();
      $grid.masonry('destroy');
      $pagination.pagination('destroy');
      $('#projectsGrid').empty();

      let url = window.location.href;
      let category = gup('category', url);
      let type = $(this).attr('id');

      let data = {
        'action'    : 'ili_project_filter',
        'category'  : category,
        'type'      : type,
      };

      $pagination.pagination({
        dataSource: function(done) {
          $.ajax({ // you can also use $.post here
            url : ili_project_filter.ajaxurl, // AJAX handler
            data : data,
            type : 'POST',
            async: true,
            success : function( response ) {
              done(response);
            },
          })
        },
        showPrevious: false,
        showNext: false,
        pageSize: 4,
        callback: function(data, pagination) {
          if (pagination.totalNumber === 0) {
            $('#pagination').hide();
            $('#notFound').show();
          } else {
            $('#pagination').show();
          }
          $('#loading').hide();
          $('#projectsGrid').html(data);
        },
        afterInit: function () {
          $grid.masonry(masonryOptions);
          $grid.imagesLoaded().progress( function() {
            $grid.masonry('layout');
          });
        },
        beforePageOnClick: function () {
          $grid.masonry('destroy');
          $('#pagination').hide();
          $('#notFound').hide();
        },
        afterPaging: function () {
          $grid.masonry(masonryOptions);
          $grid.imagesLoaded().progress( function() {
            $grid.masonry('layout');
          });
          let aTag = $('.project-types');
          $('html,body').animate({scrollTop: aTag.offset().top},'slow');
        }
      });

    });

    $('#projectTypeSelect').on('change', function () {
      $('#loading').show();
      $('#pagination').hide();
      $('#notFound').hide();
      $grid.masonry('destroy');
      $pagination.pagination('destroy');
      $('#projectsGrid').empty();

      let url = window.location.href;
      let category = gup('category', url);
      let type = $(this).val();

      let data = {
        'action'    : 'ili_project_filter',
        'category'  : category,
        'type'      : type,
      };

      $pagination.pagination({
        dataSource: function(done) {
          $.ajax({ // you can also use $.post here
            url : ili_project_filter.ajaxurl, // AJAX handler
            data : data,
            type : 'POST',
            async: true,
            success : function( response ) {
              done(response);
            },
          })
        },
        showPrevious: false,
        showNext: false,
        pageSize: 4,
        callback: function(data, pagination) {
          if (pagination.totalNumber === 0) {
            $('#pagination').hide();
            $('#notFound').show();
          } else {
            $('#pagination').show();
          }
          $('#loading').hide();
          $('#projectsGrid').html(data);
        },
        afterInit: function () {
          $grid.masonry(masonryOptions);
          $grid.imagesLoaded().progress( function() {
            $grid.masonry('layout');
          });
        },
        beforePageOnClick: function () {
          $grid.masonry('destroy');
          $('#pagination').hide();
          $('#notFound').hide();
        },
        afterPaging: function () {
          $grid.masonry(masonryOptions);
          $grid.imagesLoaded().progress( function() {
            $grid.masonry('layout');
          });
          let aTag = $('.project-types');
          $('html,body').animate({scrollTop: aTag.offset().top},'slow');
        }
      });
    });

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/projects.js